"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionPopup = void 0;
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = require("styled-components");
const Colors_1 = require("../../../../Colors");
const option_1 = require("../../../../common/option");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const server_1 = require("../../../../server");
const DSTL001_View_Child_1 = require("../../../DST/DSTL001/component/DSTL001_View_Child");
const AttachmentQuestionTable_1 = require("./AttachmentQuestionTable");
const DetailQuestionTable_1 = require("./DetailQuestionTable");
const SurveyQuestionTable_1 = require("./SurveyQuestionTable");
const SubmissionPopupStyled = styled_components_1.styled.div `
	border-width: ${({ $isDesktop }) => (!$isDesktop ? '0' : ' 0px 0px 1px 0px;')};
	border-style: solid;
	border-color: var(--color-grey-w, #b6bac0);

	${({ $isMobile }) => $isMobile &&
    `
		width: 100%;
		height: auto;
	`}

	${({ $isDesktop }) => $isDesktop &&
    `
	.empty_data {
		flex: unset;
		height: 240px;
	}
	`}

	.txt {
		color: var(--color-black, #101010);
		text-align: right;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 22px);
		letter-spacing: var(--b4-letter-spacing, -0.02em);
		font-weight: var(--b4-font-weight, 400);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;

		min-height: fit-content;
		${({ $isDesktop }) => !$isDesktop &&
    `
			width: 100%;
			justify-content: center;
			padding-bottom: 12px;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;

		`}

		.txt-span4 {
			color: var(--color-black, #101010);
			font-family: 'Noto Sans KR', sans-serif;
			font-size: ${({ $isDesktop }) => $isDesktop ? ` var(--b3-font-size, 16px)` : `var(--b4-font-size, 14px)`};
			line-height: ${({ $isDesktop }) => $isDesktop ? `var(--b3-line-height, 32px)` : `var(--b4-line-height, 22px)`};
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 400);
		}

		.txt-span5 {
			color: var(--color-black, #101010);
			font-family: 'Noto Sans KR', sans-serif;
			font-size: ${({ $isDesktop }) => $isDesktop ? ` var(--b3-font-size, 16px)` : `var(--b4-font-size, 14px)`};
			line-height: ${({ $isDesktop }) => $isDesktop ? `var(--b3-line-height, 32px)` : `var(--b4-line-height, 22px)`};
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 700);
		}
	}
`;
exports.SubmissionPopup = react_1.default.memo(({ test_id, member_id, item, props, isClosed, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [isSubmit, setIsSubmit] = react_1.default.useState(false);
    const { data: answerData, refetch: answerRefetch } = (0, server_1.useAnswerList)({
        test_id,
        from: member_id,
        orderby: 'value',
    });
    const refetchList = (0, lodash_1.throttle)(answerRefetch, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        member_id && test_id && refetchList();
    }, [member_id, test_id, isSubmit]);
    (0, react_1.useEffect)(() => {
        if (!answerData)
            return;
        if (answerData.found_count > 0) {
            setIsSubmit(true);
        }
        else {
            setIsSubmit(false);
        }
    }, [answerData]);
    const type = react_1.default.useMemo(() => item?.type, [item?.type]);
    const renderContent = () => {
        if (!item)
            return null;
        if (item.status === 'created' || (item.status === 'closed' && !isSubmit)) {
            const title = item.status === 'created'
                ? t('assignment.notOpen', {
                    name: t(`assignment.${props.isTest ? 'test' : 'name'}`),
                })
                : t('assignment.notSubmit');
            return (react_1.default.createElement(option_1.EmptyTable, { title: title, iconProps: {
                    icon: 'detail-delete',
                    size: isMobile ? 28 : 32,
                    fill: Colors_1.Colors.w_grey,
                } }));
        }
        else {
            switch (type) {
                case '설문형':
                    return (react_1.default.createElement(SurveyQuestionTable_1.SurveyQuestionTable, { ...props, item: item, isTest: item.assignment ? false : true, isSurvey: props?.isSurvey, isOpen: item?.status === 'open' ? true : false, answerData: answerData, isSubmit: isSubmit }));
                case '파일첨부형':
                    return (react_1.default.createElement(AttachmentQuestionTable_1.AttachmentQuestionTable, { ...props, item: item, isTest: item.assignment ? false : true, isOpen: item?.status === 'open' ? true : false, answerData: answerData, isSubmit: isSubmit }));
                default:
                    if (isSubmit) {
                        return (react_1.default.createElement(DSTL001_View_Child_1.ErrataTable, { ...props, item: item, isTest: item.assignment ? false : true, isOpen: item?.status === 'open' ? true : false, isSubmit: isSubmit }));
                    }
                    return (react_1.default.createElement(DetailQuestionTable_1.DetailQuestionTable, { ...props, item: item, isOpen: item?.status === 'open' ? true : false, subject_name: props.subject_name, isSubmit: isSubmit, isTest: item.assignment ? false : true }));
            }
        }
    };
    return (react_1.default.createElement(SubmissionPopupStyled, { className: "frame-987345", "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop },
        isDesktop && isClosed && (react_1.default.createElement("div", { className: "title" }, t('assignment.detailQuestions'))),
        item && renderContent(),
        isSubmit && type !== '설문형' && react_1.default.createElement("div", { className: "status-panel" })));
});
